export enum EWallets {
  Beans = 'beans',
  Lobstr = 'lobstr',
  TrustWallet = 'trustWallet',
  Test = 'test',
}
